import pkg from "../package.json"

export const VERSION: string = pkg.version
export const SERVER_NAME = "israel-statistics-mcp"
export const REPO_URL = "https://github.com/reuvenaor/israel-statistics-mcp"
